// @ts-expect-error -- untyped module
import zconnectLogo from "@assets/logo/zconnect-logo.svg";
// @ts-expect-error -- untyped module
import zconnect from "@assets/logo/zconnect.svg";

// @ts-expect-error -- untyped module
import joinhealth from "@assets/logo/joinhealth.svg";

// @ts-expect-error -- untyped module
import boonLogo from "@assets/logo/boon-logo.svg";
// @ts-expect-error -- untyped module
import boon from "@assets/logo/boon.svg";

// @ts-expect-error -- untyped module
import bluewaterLogo from "@assets/logo/bluewater-logo.svg";
// @ts-expect-error -- untyped module
import bluewater from "@assets/logo/bluewater.svg";

// @ts-expect-error -- untyped module
import leading from "@assets/logo/leading.svg";
// @ts-expect-error -- untyped module
import pbaLogo from "@assets/logo/pba-logo.svg";
// @ts-expect-error -- untyped module
import cookLogo from "@assets/logo/cook-logo.svg";
// @ts-expect-error -- untyped module
import vitoriLogo from "@assets/logo/vitori-logo.svg";
// @ts-expect-error -- untyped module
import pbsLogo from "@assets/logo/pbs-logo.svg";
// @ts-expect-error -- untyped module
import jpfarleyLogo from "@assets/logo/jpfarley-logo.svg";

import type { Theme as BaseTheme } from "@/context/theme-provider";

export type Theme = BaseTheme & {
  groupId: string;
  name: string;
  logo: string;
  icon: string;
  favicon: string;
};

export const FONT_FAMILY = {
  POPPINS: "Poppins",
  ROBOTO: "Roboto",
};

// @ts-expect-error -- untyped module
import edisonLogo from "@assets/logo/edison-logo.svg";
// @ts-expect-error -- untyped module
import edison from "@assets/logo/edison.svg";

// @ts-expect-error -- untyped module
import voyagerLogo from "@assets/logo/voyager-logo.svg";
// @ts-expect-error -- untyped module
import voyager from "@assets/logo/voyager.svg";

// @ts-expect-error -- untyped module
import decentLogo from "@assets/logo/decent-logo.svg";
// @ts-expect-error -- untyped module
import decent from "@assets/logo/decent.svg";

import { getItem, setItem } from "@/lib/storage-utils";
import { STORAGE, STORAGE_KEY } from "@/constants";
import { lowerCaseComparison } from "@/lib/string-util";
import { PRODUCT_NAME } from "@/lib/client-utils";

//https://uicolors.app/generate/

// https://colorkit.co/color/ (new color reference)

export const flavours = {
  zconnect: {
    appName: PRODUCT_NAME.ZCONNECT,
    groupId: "Z5DEMO_B",
    name: "zConnect Health",
    logo: zconnectLogo,
    icon: zconnect,
    favicon: "zconnect",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#2A90FF",
      primaryLight: "#d8eaff",
      primaryExtraLight: "#ebf5ff",
      primaryDark: "#1c6abe",
      primaryExtraDark: "#16579e",
      primarySelected: "#237dde",
      primaryForeground: "#ffffff",

      secondary: "#FF9F3B",
      secondaryLight: "#ffeddc",
      secondaryExtraLight: "#fff6ed",
      secondaryDark: "#be7529",
      secondaryExtraDark: "#9e6121",
      secondarySelected: "#de8a32",
      secondaryForeground: "#ffffff",
    },
    appStoreLink: "https://apps.apple.com/app/zconnect-health/id1519993197",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.zakipoint.zconnect",
  },

  joinhealth: {
    appName: PRODUCT_NAME.COBALT,
    groupId: "COBALT",
    name: "JoinHealth",
    logo: joinhealth,
    icon: joinhealth,
    favicon: "joinhealth",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#005EB8",
      primaryLight: "#d2e2f2",
      primaryExtraLight: "#e8f0f9",
      primaryDark: "#005088",
      primaryExtraDark: "#004171",
      primarySelected: "#005fa0",
      primaryForeground: "#ffffff",

      secondary: "#A42036",
      secondaryLight: "#f2d4d4",
      secondaryExtraLight: "#f9e9e9",
      secondaryDark: "#791525",
      secondaryExtraDark: "#640f1e",
      secondarySelected: "#8e1a2e",
      secondaryForeground: "#ffffff",
    },
    appStoreLink: "",
    playStoreLink: "",
  },

  boon: {
    appName: PRODUCT_NAME.ZCONNECT,
    groupId: "BOONCHAPMAN",
    name: "Boon Chapman",
    logo: boonLogo,
    icon: boon,
    favicon: "boon",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#38004A",
      primaryLight: "#d4c9d9",
      primaryExtraLight: "#eae4ec",
      primaryDark: "#270035",
      primaryExtraDark: "#1f002a",
      primarySelected: "#2f003f",
      primaryForeground: "#ffffff",

      secondary: "#008291",
      secondaryLight: "#d4e5e8",
      secondaryExtraLight: "#e9f2f4",
      secondaryDark: "#005f6a",
      secondaryExtraDark: "#004e58",
      secondarySelected: "#00707d",
      secondaryForeground: "#ffffff",
    },
    appStoreLink: "",
    playStoreLink: "",
  },

  voyager: {
    appName: PRODUCT_NAME.VOYAGER,
    groupId: "SMHA",
    name: "Valenz Health Voyager",
    logo: voyagerLogo,
    icon: voyager,
    favicon: "voyager",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#004E59",
      primaryLight: "#cdd9dc",
      primaryExtraLight: "#e6eced",
      primaryDark: "#003840",
      primaryExtraDark: "#002d34",
      primarySelected: "#00434c",
      primaryForeground: "#ffffff",

      secondary: "#FD7900",
      secondaryLight: "#ffe6d6",
      secondaryExtraLight: "#fff2eb",
      secondaryDark: "#bc5800",
      secondaryExtraDark: "#9d4800",
      secondarySelected: "#dc6800",
      secondaryForeground: "#ffffff",
    },
    appStoreLink:
      "https://apps.apple.com/np/app/valenz-health-voyager/id6504086955",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.zakipoint.voyager",
  },

  bluewater: {
    appName: PRODUCT_NAME.BLUEWATER,
    groupId: "BLUEWATER",
    name: "Blue Water Health Connect",
    logo: bluewaterLogo,
    icon: bluewater,
    favicon: "bluewater",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#01AED9",
      primaryLight: "#d9eff8",
      primaryExtraLight: "#ecf7fc",
      primaryDark: "#0180a1",
      primaryExtraDark: "#006a86",
      primarySelected: "#0197bc",
      primaryForeground: "#ffffff",

      secondary: "#F6CA4E",
      secondaryLight: "#fdf5e0",
      secondaryExtraLight: "#fefaef",
      secondaryDark: "#b79538",
      secondaryExtraDark: "#987c2d",
      secondarySelected: "#d6af43",
      secondaryForeground: "#ffffff",
    },
    appStoreLink:
      "https://apps.apple.com/np/app/blue-water-health-connect/id6611967418",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.zakipoint.bluewater",
  },

  decent: {
    appName: PRODUCT_NAME.ZCONNECT,
    groupId: "DECENT",
    name: "Decent",
    logo: decentLogo,
    icon: decent,
    favicon: "decent",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#F05D5F",
      primaryLight: "#ffe0de",
      primaryExtraLight: "#fff0ee",
      primaryDark: "#b24344",
      primaryExtraDark: "#953738",
      primarySelected: "#d15052",
      primaryForeground: "#ffffff",

      secondary: "#225372",
      secondaryLight: "#d1dbe2",
      secondaryExtraLight: "#e8edf0",
      secondaryDark: "#163b53",
      secondaryExtraDark: "#113044",
      secondarySelected: "#1c4762",
      secondaryForeground: "#ffffff",
    },
    appStoreLink: "",
    playStoreLink: "",
  },

  edison: {
    appName: PRODUCT_NAME.EDISON,
    groupId: "LEVEL_EDISON",
    name: "Edison Connect",
    logo: edisonLogo,
    icon: edison,
    favicon: "edison",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#2771A5",
      primaryLight: "#d4e2ee",
      primaryExtraLight: "#e9f0f6",
      primaryDark: "#1a5279",
      primaryExtraDark: "#144365",
      primarySelected: "#20618f",
      primaryForeground: "#ffffff",

      secondary: "#a55b27", //no secondary color so complementary color used
      secondaryLight: "#efddd3",
      secondaryExtraLight: "#f7eee9",
      secondaryDark: "#79411a",
      secondaryExtraDark: "#653514",
      secondarySelected: "#8f4e20",
      secondaryForeground: "#ffffff",
    },
    appStoreLink: "https://apps.apple.com/us/app/edison-connect/id6748272172",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.ehs.econnect",
  },

  leading: {
    appName: PRODUCT_NAME.LEADING,
    groupId: "LEADING",
    name: "Leading Edge Administrators",
    logo: leading,
    icon: leading,
    favicon: "leading",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#0f73ad",
      primaryLight: "#d4c9d9",
      primaryExtraLight: "#eae4ec",
      primaryDark: "#045cb4",
      primaryExtraDark: "#04498d",
      primarySelected: "#0f73ad",
      primaryForeground: "#ffffff",

      secondary: "#ad1f25",
      secondaryLight: "#d4e5e8",
      secondaryExtraLight: "#e9f2f4",
      secondaryDark: "#b20d14",
      secondaryExtraDark: "#b2080f",
      secondarySelected: "#ad1f25",
      secondaryForeground: "#ffffff",
    },
    appStoreLink: "https://apps.apple.com/app/zconnect-health/id6759092224",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.zakipoint.mylea",
  },

  pba: {
    appName: PRODUCT_NAME.PBA,
    groupId: "PBA",
    name: "Professional Benefit Administrators",
    logo: pbaLogo,
    icon: pbaLogo,
    favicon: "pba",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#024D74",
      primaryLight: "#98c8e7",
      primaryExtraLight: "#a5cfea",
      primaryDark: "#023a57",
      primaryExtraDark: "#011d2c",
      primarySelected: "#4295c9",
      primaryForeground: "#ffffff",

      secondary: "#f38e1d",
      secondaryLight: "#fdc04f",
      secondaryExtraLight: "#fee0a7",
      secondaryDark: "#e4861c",
      secondaryExtraDark: "#d57d1a",
      secondarySelected: "#f38e1d",
      secondaryForeground: "#ffffff",
    },
    appStoreLink:
      "https://apps.apple.com/us/app/pba-member-portal/id6761747024",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.pba.mbrportal",
  },
  cook: {
    appName: PRODUCT_NAME.COOK,
    groupId: "COOK",
    name: "Cook Medical",
    logo: cookLogo,
    icon: cookLogo,
    favicon: "cook",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#9c0f1c",
      primaryLight: "#f0a5ad",
      primaryExtraLight: "#f5c3c8",
      primaryDark: "#640c11",
      primaryExtraDark: "#540a0e",
      primarySelected: "#890f19",
      primaryForeground: "#ffffff",

      secondary: "#39738e",
      secondaryLight: "#7ca6ca",
      secondaryExtraLight: "#d6e4ed",
      secondaryDark: "#25566c",
      secondaryExtraDark: "#1e4c60",
      secondarySelected: "#2c6077",
      secondaryForeground: "#ffffff",
    },
    appStoreLink: "",
    playStoreLink: "",
  },

  vitori: {
    appName: PRODUCT_NAME.VITORI,
    groupId: "VITORI",
    name: "Vitori Health",
    logo: vitoriLogo,
    icon: vitoriLogo,
    favicon: "vitori",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#244576",
      primaryLight: "#d3dceb",
      primaryExtraLight: "#e9eef6",
      primaryDark: "#1B355A",
      primaryExtraDark: "#162C4A",
      primarySelected: "#203E6B",
      primaryForeground: "#ffffff",

      secondary: "#4ABCC6",
      secondaryLight: "#D8F1F3",
      secondaryExtraLight: "#ECF9FA",
      secondaryDark: "#38929A",
      secondaryExtraDark: "#2E7980",
      secondarySelected: "#41A8B1",
      secondaryForeground: "#ffffff",
    },
    appStoreLink: "",
    playStoreLink: "",
  },

  pbs: {
    appName: PRODUCT_NAME.PBS,
    groupId: "PBS",
    name: "Professional Benefit Services, Inc.",
    logo: pbsLogo,
    icon: pbsLogo,
    favicon: "pbs",
    theme: {
      fontFamily: FONT_FAMILY.ROBOTO,
      primary: "#203a70",
      primaryLight: "#acb6ca",
      primaryExtraLight: "#c8cedc",
      primaryDark: "#142546",
      primaryExtraDark: "#101d38",
      primarySelected: "#1c3362",
      primaryForeground: "#ffffff",

      secondary: "#808285",
      secondaryLight: "#d0d1d2",
      secondaryExtraLight: "#e0e0e1",
      secondaryDark: "#606264",
      secondaryExtraDark: "#404143",
      secondarySelected: "#707275",
      secondaryForeground: "#ffffff",
    },
    appStoreLink: "https://apps.apple.com/app/zconnect-health/id6802220276",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.zakipoint.pbs",
  },
  jpfarley: {
    appName: PRODUCT_NAME.JPFARLEY,
    groupId: "JPFARLEY",
    name: "J.P. Farley Connect",
    logo: jpfarleyLogo,
    icon: jpfarleyLogo,
    favicon: "jpfarley",
    theme: {
      fontFamily: FONT_FAMILY.POPPINS,
      primary: "#16457A",
      primaryLight: "#D3DCE6",
      primaryExtraLight: "#E9EDF2",
      primaryDark: "#103157",
      primaryExtraDark: "#0D2847",
      primarySelected: "#133B68",
      primaryForeground: "#FFFFFF",

      secondary: "#C70700",
      secondaryLight: "#F4D0CF",
      secondaryExtraLight: "#FAE7E7",
      secondaryDark: "#8E0500",
      secondaryExtraDark: "#730400",
      secondarySelected: "#AA0600",
      secondaryForeground: "#FFFFFF",
    },
    appStoreLink: "https://apps.apple.com/app/zconnect-health/id6812191726",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.zakipoint.jpfarley",
  },
};

export const getProductConfig = () => {
  const productSessionConfig = getItem(
    STORAGE_KEY.PRODUCT_CONFIG,
    STORAGE.SESSION,
  );
  if (productSessionConfig && Object.keys(productSessionConfig).length > 0) {
    const productConfig = productSessionConfig;
    return productConfig;
  }
  let productConfig: (typeof flavours)[keyof typeof flavours] =
    flavours.zconnect;
  if (
    window.location.hostname.includes("webapp.zakipointhealth.com") ||
    window.location.hostname.includes("webapp-uat.zakipointhealth.com") ||
    window.location.hostname.includes("webapp-dev.zakipointhealth.com")
  ) {
    productConfig = flavours.zconnect;
  } else if (
    window.location.hostname.includes("bluewaterbenefitsadmin.com") ||
    window.location.hostname.includes("bwba.zakipointhealth.com") ||
    window.location.hostname.includes("bluewater-uat.z5p.us")
  ) {
    productConfig = flavours.bluewater;
  } else if (window.location.hostname.includes("edisonehs.com")) {
    productConfig = flavours.edison;
  } else if (
    window.location.hostname.includes("cobaltbenefitsgroup.com") ||
    window.location.hostname.includes("joinhealth-uat.z5p.us") ||
    window.location.hostname.includes("joinhealth-dev.z5p.us")
  ) {
    productConfig = flavours.joinhealth;
  } else if (window.location.hostname.includes("valenzhealth.com")) {
    productConfig = flavours.voyager;
  } else if (
    window.location.hostname.includes("mylea-dev.z5p.us") ||
    window.location.hostname.includes("mylea-uat.z5p.us") ||
    window.location.hostname.includes("member.mylea.app")
  ) {
    productConfig = flavours.leading;
  } else if (window.location.hostname.includes("cook.zakipointhealth.com")) {
    productConfig = flavours.cook;
  } else if (
    window.location.hostname.includes("pba-dev.zakipointhealth.com") ||
    window.location.hostname.includes("webpba-uat.zakipointhealth.com") ||
    window.location.hostname.includes("member.pbaclaims.com")
  ) {
    productConfig = flavours.pba;
  } else if (
    window.location.hostname.includes("webapp-dev.vitorihealth.com") ||
    window.location.hostname.includes("vitorihealth-uat.z5p.us") ||
    window.location.hostname.includes("webapp.vitorihealth.com")
  ) {
    productConfig = flavours.vitori;
  } else if (
    window.location.hostname.includes("pbs-uat.z5p.us") ||
    window.location.hostname.includes("myhealth.zakipointhealth.com")
  ) {
    productConfig = flavours.pbs;
  } else if (
    window.location.hostname.includes("jpfarley-uat.z5p.us") ||
    window.location.hostname.includes("jpfarley.zakipointhealth.com")
  ) {
    productConfig = flavours.jpfarley;
  } else {
    productConfig = flavours.zconnect;
  }
  return productConfig;
};

export const getFlavourFor = (groupId: string, divisionId?: string) => {
  if (
    !window.location.hostname.includes("zakipointhealth.com") &&
    !window.location.hostname.includes("localhost")
  )
    return null; //white labelling flow.

  if (groupId.startsWith("COBALT")) {
    return flavours.joinhealth;
  }

  switch (groupId) {
    case "BOONCHAPMAN":
      return flavours.boon;
    case "DECENT":
      return flavours.decent;
    case "UGS":
      return flavours.voyager;
    case "BLUEWATER":
      return flavours.bluewater;
    case "LEVEL_EDISON":
      return flavours.edison;
    case "LEADING":
      return flavours.leading;
    case "PBA":
      if (lowerCaseComparison(divisionId, "cook")) return flavours.cook;
      return flavours.pba;
    case "VITORI":
      return flavours.vitori;
    case "PBS":
      return flavours.pbs;
    case "JPFARLEY":
      return flavours.jpfarley;
    default:
      return flavours.zconnect;
  }
};

export const initializeProductConfig = async (): Promise<Theme> => {
  return new Promise((resolve, reject) => {
    //TODO: we make a call to remote server here to get the product config
    try {
      const productConfig = getProductConfig();
      document.title = productConfig.name;
      const link =
        document.querySelector("link[rel='icon']") ||
        document.createElement("link");

      link.setAttribute("rel", "icon");
      link.setAttribute("type", "image/x-icon");
      link.setAttribute("href", `/favicons/${productConfig.favicon}.ico`);
      document.head.appendChild(link);

      (window as Window & { __PRODUCT_CONFIG__: unknown }).__PRODUCT_CONFIG__ =
        productConfig;
      setItem(STORAGE_KEY.PRODUCT_CONFIG, productConfig, STORAGE.SESSION);
      // Resolve the promise when everything is successful
      resolve({
        ...productConfig.theme,
        groupId: productConfig.groupId,
        name: productConfig.name,
        logo: productConfig.logo,
        icon: productConfig.icon,
        favicon: productConfig.favicon,
      });
    } catch (error) {
      // Reject the promise if there is an error
      reject(error);
    }
  });
};
